module.exports = __webpack_public_path__ + "static/media/TheImmigrantDream.65abb550.jpg";